import { useTranslation } from 'react-i18next';
import styles from './CollectAreaStatusIcon.module.scss';
import { mergeClasses } from 'util/commons';

type CollectAreaStatusIconProps = {
  collectRequestFlg?: boolean;
  emissionFlg?: boolean;
  substituteFlg?: boolean;
  collectedFlg?: boolean;
  hasMemo?: boolean;
  className?: string;
  showEmptyStatus?: boolean;
  onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
};

export function CollectAreaStatusIcon({
  collectRequestFlg,
  emissionFlg,
  substituteFlg,
  collectedFlg,
  hasMemo,
  className,
  showEmptyStatus = true,
  onClick,
}: CollectAreaStatusIconProps) {
  const { t } = useTranslation();

  if (substituteFlg) {
    return (
      <div className={className} onClick={onClick}>
        <div className={mergeClasses(styles.tag, styles.statusSubstitute)}>
          {t('collects.label_substitute')}
        </div>
      </div>
    );
  }

  if (collectedFlg) {
    return (
      <div className={className} onClick={onClick}>
        <div className={mergeClasses(styles.tag, styles.statusCollected)}>
          {t('collects.label_collected')}
        </div>
      </div>
    );
  }

  if (collectRequestFlg) {
    return (
      <div className={className} onClick={onClick}>
        <div className={mergeClasses(styles.tag)}>
          {t('collects.label_collection_request')}
        </div>
      </div>
    );
  }

  if (emissionFlg) {
    return (
      <div className={className} onClick={onClick}>
        <div className={mergeClasses(styles.tag, styles.statusEmission)}>
          {t('collects.label_collection_registered')}
        </div>
      </div>
    );
  }

  if (hasMemo) {
    return (
      <div className={className} onClick={onClick}>
        <div className={mergeClasses(styles.tag, styles.hasMemo)}>
          {t('collects.label_memo')}
        </div>
      </div>
    );
  }

  if (!showEmptyStatus) {
    return null;
  }

  return (
    <div className={className}>
      <div className={mergeClasses(styles.tag, styles.statusEmpty)}>
        {t('collects.label_empty')}
      </div>
    </div>
  );
}
